// extracted by mini-css-extract-plugin
export default {"container":"agm_container__F-IpP","boxes":"agm_boxes__V-JMU","head":"agm_head__riywQ"};